module.exports = {"fb_lang":"en_US","mapCenter":{"lat":"1.352083","lng":"103.819836"},"geocomplete_country":"sg","PHONE_REGEX":"^([36]\\d{7}|[78][1-9]\\d{6}|[9][0-8]\\d{6})$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-SG":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/sg/scripts/components/setting.json
// module id = 857
// module chunks = 0 1 2 3 4 5